/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
import React, { useMemo, memo } from 'react';
import { useSelector } from 'react-redux';
import { Product, ProductType } from '~redux/brand/types';
import { buyerInfoSelector } from '~redux/buyer/selectors';
import { Hit } from 'react-instantsearch-core';
import ProductListViewItem from '../ProductListViewItem';
import { getPublicImageUrl } from '~utils/image';
import { ProductReadModel } from '~types/api';

interface Props {
  productJson: Hit<ProductReadModel>;
}

interface HitComponentProps extends Props {
  border?: boolean;
  index: number;
  col?: boolean;
  showBrand?: boolean;
  indexName?: string;
  layout?: 'grid' | 'detail';
  preview?: boolean;
  isLongListView?: boolean;
  moveFavoriteList?: boolean;
}

export const ProductListViewItemByAlgolia: React.FC<HitComponentProps> = memo(
  ({ productJson, ...props }) => {
    const buyerInfo = useSelector(buyerInfoSelector);
    const discount = useMemo(
      () =>
        buyerInfo?.contacts?.items?.find(
          (item) => item.brand_owner === productJson.product_owner
        ),
      [buyerInfo, productJson]
    );
    const product: Product = useMemo(
      () => ({
        ...productJson,
        product_brand_id: productJson.brand_id,
        product_public_status: productJson.is_published ? '公開' : '非公開',
        producttype: productJson.options,
        brand: {
          id: productJson.brand_id,
          brand_name: productJson.brand_name,
          brand_minimum_buy: productJson.brand_minimum_buy,
          brand_additional_minimum_buy:
            productJson.brand_additional_minimum_buy,
        },
        imageKeys: productJson.image_keys?.map((imageKey) => ({ imageKey })),
        videoKeys: productJson.video_keys?.map((videoKey) => ({ videoKey })),
        imageUrl: getPublicImageUrl(productJson.image_key),
        discount: discount
          ? {
              items: [discount],
            }
          : null,
      }),
      [buyerInfo, productJson]
    );

    return (
      <ProductListViewItem
        product={product as Product}
        productTypes={(productJson.options as unknown) as ProductType[]}
        {...props}
      />
    );
  }
);
